import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
function PaymentEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState("");
  const today = dayjs();
  const [paymentDate, setpaymentDate] = useState(null);
  const [co6Number, setco6Number] = useState();
  const [co6Date, setco6Date] = useState(null);

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;

  const [returnData, setreturnData] = useState([]);
  const [payreturnData, setpayreturnData] = useState([]);

  const [co7Number, setco7Number] = useState();
  const [co7Date, setco7Date] = useState(null);

  const handleClose = () => {
    navigate("../paymentlist", { replace: true });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [errors, setErrors] = useState({});

  const InsertPOData = async (e) => {
    e.preventDefault();

    let formErrors = {};

   // if (co6dateerror) formErrors.errco6date = "Invalid CO6 Date";
   // if (co7dateerror) formErrors.errco7date = "Invalid CO7 Date";
   // if (paymentdateerror) formErrors.errpaymentdate = "Invalid Payment Date";

   if (!paymentDate) {formErrors.errpaymentdate = "Invalid Payment Date";}
   if (!co6Date) {formErrors.errco6date = "Invalid CO6 Date";}
   if (!co7Date) {formErrors.errco7date = "Invalid CO7 Date";}





    if (!co6Number || co6Number.length === 0)
      formErrors.errco6 = "Invalid CO6 Number";

    if (!co7Number || co7Number.length === 0)
      formErrors.errco7 = "Invalid CO7 Number";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const payedt = new Date(paymentDate);
      const paydate =
        payedt.getFullYear() +
        "/" +
        parseInt(payedt.getMonth() + 1) +
        "/" +
        payedt.getDate();

      const co6dt = new Date(co6Date);
      const co6dtdate =
        co6dt.getFullYear() +
        "/" +
        parseInt(co6dt.getMonth() + 1) +
        "/" +
        co6dt.getDate();

      const co7dt = new Date(co7Date);
      const co7dtdate =
        co7dt.getFullYear() +
        "/" +
        parseInt(co7dt.getMonth() + 1) +
        "/" +
        co7dt.getDate();

      apiClient.post("/PaymentEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList,
          vco6number: co6Number,
          vco6date: co6dtdate,
          vco7number: co7Number,
          vco7date: co7dtdate,
          vpaymentdate: paydate,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          setError(response.data);
          navigate("../paymentlist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate CO6 Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
    apiClient.post("/podetailscrn", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
      })
      .catch(function (error) {
        setError(error);
      });

    apiClient.post("/podetailspayment", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setpayreturnData(response.data[0]);
      })
      .catch(function (error) {
        setError(error);
      });
  };

  useEffect(() => {
    getdata();
  },[]);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Date", "Paymenttype"],
    ["Bill Number", "Billed Item Qty", "Billed Value"],
    ["Bill Passing Date", "CRN Number", "CRN Date"],
    ["Hardcopy Sent to Account", "", ""],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billdate, returnData.paymentDesription],
    [returnData.billnumber, returnData.billitemQty, returnData.billitemValue],
    [returnData.billpassingdate, returnData.crnnumber, returnData.crndate],
    [returnData.billsenttoaccountdate, "", ""],
  ];

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
  <Box
    className="payment-entry-page"
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      px: { xs: 0.75, sm: 1.25, md: 2 },
      py: { xs: 0.75, sm: 1, md: 1.5 },
      overflowX: "hidden",
    }}
  >
    <Card
      className="payment-entry-card"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 3 },
        border: "1px solid #dbe5f1",
        background: "#fff",
        boxShadow: "0 8px 28px rgba(13, 71, 161, 0.10)",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.3, sm: 1.5, md: 1.7 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.1rem",
              md: "1.25rem",
            },
            fontWeight: 700,
            lineHeight: 1.3,
          }}
        >
          Payment Date
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1, sm: 1.5, md: 2 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= PO DETAILS ================= */}
        <Accordion
          defaultExpanded
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            mb: { xs: 1.5, md: 2 },
            border: "1px solid #dbe5f1",
            borderRadius: "10px !important",
            overflow: "hidden",
            boxShadow: "none",

            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={
              <ArrowDownwardIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 20, md: 24 },
                }}
              />
            }
            sx={{
              minHeight: { xs: 48, sm: 52 },
              px: { xs: 1.5, sm: 2 },
              background:
                "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
              color: "#fff",

              "& .MuiAccordionSummary-content": {
                my: { xs: 1, sm: 1.2 },
              },

              "&.Mui-expanded": {
                minHeight: { xs: 48, sm: 52 },
              },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem",
                  md: "1.05rem",
                },
                fontWeight: 700,
              }}
            >
              PO Details
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              p: { xs: 0.75, sm: 1, md: 1.5 },
              background: "#f8fbff",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              <ListHeaderTableComponent
                headers={headers}
                rows={rows}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* ================= PAYMENT INFORMATION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f1",
            borderRadius: 2,
            background: "#fff",
            p: { xs: 1.25, sm: 1.5, md: 2 },
            mb: { xs: 1.5, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "0.9rem",
                sm: "0.95rem",
                md: "1rem",
              },
              fontWeight: 700,
              color: "#0D47A1",
              mb: { xs: 1.25, sm: 1.5 },
              pl: 1,
              borderLeft: "4px solid #1976D2",
              lineHeight: 1.4,
            }}
          >
            Payment Information
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "1fr 1fr 1fr",
              },
              gap: { xs: 1.5, sm: 2, md: 2.5 },
              width: "100%",
              minWidth: 0,
            }}
          >
            {/* ================= CO6 ================= */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              <CustomTextField
                label="CO6 Number"
                value={co6Number ?? ""}
                onChange={(e) => {
                  setco6Number(e.target.value);
                }}
                placeholder="CO6 Number"
                maxLength={50}
                error={!!errors.errco6}
                helperText={errors.errco6}
              />

              <DatePickerComponent
                label="Date of CO6"
                id="co6date"
                value={co6Date}
                onChange={(newDate) =>
                  handleDateChange(
                    newDate,
                    setco6Date
                  )
                }
                error={errors.errco6date}
                maxDate={today}
                minDate={
                  returnData.billpassingdate
                    ? dayjs(returnData.billpassingdate)
                    : dayjs()
                }
              />
            </Box>

            {/* ================= CO7 ================= */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              <CustomTextField
                label="CO7 Number"
                value={co7Number ?? ""}
                onChange={(e) => {
                  setco7Number(e.target.value);
                }}
                placeholder="CO7 Number"
                maxLength={50}
                error={!!errors.errco7}
                helperText={errors.errco7}
              />

              <DatePickerComponent
                label="Date of CO7"
                id="co7date"
                value={co7Date}
                onChange={(newDate) =>
                  handleDateChange(
                    newDate,
                    setco7Date
                  )
                }
                error={errors.errco7date}
                maxDate={today}
                minDate={
                  returnData.billpassingdate
                    ? dayjs(returnData.billpassingdate)
                    : dayjs()
                }
              />
            </Box>

            {/* ================= FINAL PAYMENT ================= */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                justifyContent: "flex-start",
              }}
            >
              <Box
                sx={{
                  display: {
                    xs: "none",
                    sm: "block",
                    md: "block",
                  },
                  height: {
                    sm: 56,
                    md: 56,
                  },
                }}
              />

              <DatePickerComponent
                label="Final Payment Date"
                id="paymentDate"
                value={paymentDate}
                onChange={(newDate) =>
                  handleDateChange(
                    newDate,
                    setpaymentDate
                  )
                }
                error={errors.errpaymentdate}
                maxDate={today}
                minDate={
                  returnData.billpassingdate
                    ? dayjs(returnData.billpassingdate)
                    : dayjs()
                }
              />
            </Box>
          </Box>
        </Box>

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
            },
            gap: { xs: 1, sm: 1.5, md: 2 },
          }}
        >
          <button
            type="button"
            onClick={InsertPOData}
            title="Click for Data Save"
            className="payment-action-btn payment-save-btn"
          >
            Save Data
          </button>

          <button
            type="button"
            onClick={handleClose}
            title="Close"
            className="payment-action-btn payment-close-btn"
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>

    {/* ================= RESPONSIVE CSS ================= */}
    <style>{`
      .payment-entry-page,
      .payment-entry-page * {
        box-sizing: border-box;
      }

      .payment-entry-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow-x: hidden;
      }

      .payment-entry-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* =========================================
         TABLE WIDTH / TEXT WRAPPING
         ========================================= */

      .payment-entry-card table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        table-layout: fixed !important;
      }

      .payment-entry-card th,
      .payment-entry-card td {
        white-space: normal !important;
        overflow-wrap: anywhere !important;
        word-break: break-word !important;
        max-width: 0;
      }

      /* =========================================
         FORM FIELDS
         ========================================= */

      .payment-entry-card .MuiFormControl-root,
      .payment-entry-card .MuiTextField-root {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* =========================================
         BUTTONS
         ========================================= */

      .payment-action-btn {
        width: 100%;
        min-height: 44px;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        color: #fff;
        font-size: 0.9rem;
        font-weight: 700;
        cursor: pointer;
        transition:
          transform 0.18s ease,
          box-shadow 0.18s ease;
      }

      .payment-save-btn {
        background:
          linear-gradient(
            135deg,
            #1565C0 0%,
            #1976D2 100%
          );

        box-shadow:
          0 4px 12px rgba(21, 101, 192, 0.25);
      }

      .payment-close-btn {
        background:
          linear-gradient(
            135deg,
            #c62828 0%,
            #e53935 100%
          );

        box-shadow:
          0 4px 12px rgba(198, 40, 40, 0.20);
      }

      .payment-action-btn:hover {
        transform: translateY(-1px);
      }

      .payment-action-btn:active {
        transform: translateY(0);
      }

      /* =========================================
         TABLET
         ========================================= */

      @media (max-width: 900px) {
        .payment-entry-card th,
        .payment-entry-card td {
          font-size: 0.78rem !important;
          padding: 7px 5px !important;
        }
      }

      /* =========================================
         MOBILE
         ========================================= */

      @media (max-width: 600px) {
        .payment-entry-page {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }

        .payment-entry-card {
          border-radius: 10px !important;
        }

        .payment-entry-card th,
        .payment-entry-card td {
          font-size: 0.72rem !important;
          padding: 6px 4px !important;
        }

        .payment-action-btn {
          min-height: 42px;
          font-size: 0.85rem;
        }
      }

      /* =========================================
         SMALL MOBILE
         ========================================= */

      @media (max-width: 400px) {
        .payment-entry-card th,
        .payment-entry-card td {
          font-size: 0.67rem !important;
          padding: 5px 3px !important;
        }

        .payment-action-btn {
          min-height: 40px;
          font-size: 0.82rem;
        }
      }
    `}</style>
  </Box>
);
}

export default PaymentEntry;
